var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 4.9c2.9-.5 6.1-.4 8.6-.1.4.05.6.3.6.7.1 2.3.1 4.7 0 7 0 .4-.2.6-.6.65-2.7.35-5.8.35-8.5-.05-.4-.05-.6-.25-.6-.65-.1-2.25-.1-4.55.05-6.95.02-.35.15-.55.45-.6M11.6 8c1.6-1 3.1-2 4.5-2.8.3-.2.6-.05.6.3.05 2.3.05 4.6-.05 6.9-.02.4-.3.5-.65.3-1.4-.8-2.9-1.8-4.4-2.7"
  }))));
};
export default SvgVideo;